const ChartTypes = [
    'AREA',
    'BAR',
    'BUBBLE',
    'CANDLESTICK',
    'COLUMN',
    'CUSTOM_CHART',
    'FUNNEL',
    'GEO_AREA',
    'GEO_BUBBLE',
    'GEO_EARTH_AREA',
    'GEO_EARTH_BAR',
    'GEO_EARTH_BUBBLE',
    'GEO_EARTH_GRAPH',
    'GEO_EARTH_HEATMAP',
    'GEO_HEATMAP',
    'GRID_TABLE',
    'HEATMAP',
    'KPI',
    'LINE',
    'LINE_COLUMN',
    'LINE_STACKED_COLUMN',
    'PARETO',
    'PIE',
    'PIVOT_TABLE',
    'SANKEY',
    'SCATTER',
    'SPIDER_WEB',
    'STACKED_AREA',
    'STACKED_BAR',
    'STACKED_COLUMN',
    'TREEMAP',
    'WATERFALL',
    'WHISKER_SCATTER',
];
export const returnNotSupportedChartType = chartTypes => {
    return ChartTypes.filter(type => !chartTypes.includes(type));
};
//# sourceMappingURL=config-utils.js.map